<template>
  <div class="building_container">
    <PopUpModal v-if="isPopUpModal" :text="popupModalText" @close-modal="onCloseModal" />
    <!-- 큐레이션 미리 보기 -->
    <CurationInfo v-if="showCurationInfo" :curationInfo="curationInfo" @closeCurationInfo="showCurationInfo = false" />
    <!-- 임시저장 완료 -->
    <CancelModal v-if="cancelStatus" />
    <!-- 중간 저장 팝업  -->
    <CommonConfirm
      v-if="cancelCheckStatus"
      :confirmid="'cancelcheckmodal'"
      @close-modal="onCancelCheckStatusConfirmNo"
      @confirm-modal="onCancelCheckStatusConfirmYes"
    >
      <template #contents>
        <div class="stopmodal_body">
          <h3 class="stopmodal_text1">
            등록중인 스페이스를 저장할까요?
          </h3>
        </div>
      </template>
    </CommonConfirm>
    <!-- Alarm -->
    <transition name="toast">
      <div class="toast-alarm-text" v-if="isShowCurationInfo">
        클릭한 비율 위주로 큐레이션 됩니다.
      </div>
    </transition>
    <transition name="toast">
      <div class="toast-alarm-text" v-if="isShowOverValue">
        국내곡 비율은 최대 80%까지 선택 가능합니다.
      </div>
    </transition>

    <!-- 스페이스 등록 템플릿 -->
    <SpaceManageSlot :progress="60" :closefn="backPage">
      <template #pagename>
        스페이스 등록
      </template>

      <template #spacestatus>
        국내곡 비율은 어느 정도로 해드릴까요?
      </template>

      <template #spacebody>
        <div v-if="domesticRate > -1">
          <BuildingProgressBar :value="domesticRate" @click-dot="onClickDot" @click-overvalue="onClickOverValue" />
        </div>

        <!-- 국내 / 해외 곡 비율 Text -->
        <div class="rate_bar_txt">
          <p>
            국내 <span>{{ domesticRate }}</span> %
          </p>
          <p>
            해외 <span>{{ foreignRate }}</span> %
          </p>
        </div>
      </template>
    </SpaceManageSlot>
    <!-- Footer -->
    <BuildingManageFooter
      :rightbtndisabled="rightBtnDisabled"
      :leftbtnfn="onClickPre"
      :rightbtnfn="updateCurationStore"
    >
      <template #footerleft>
        <PreViewSelectCuration
          :color="color"
          :selectkey="['color', 'material', 'target']"
          :material="bottomMaterialList"
          :target="target"
          @click-detailmodal="onClickDetailModal"
        />
      </template>
    </BuildingManageFooter>
  </div>
</template>
<script>
import CancelModal from '@/components/modal/Space/CancelModal.vue';
import CommonConfirm from '@/components/common/CommonConfirm.vue';
import SpaceManageSlot from '@/slot/SpaceManageSlot.vue';
import BuildingProgressBar from '@/components/Building/BuildingProgressBar.vue';
import BuildingManageFooter from '@/components/Building/BuildingManageFooter.vue';
import PreViewSelectCuration from '@/components/Building/PreViewSelectCuration.vue';
import CurationInfo from '@/components/modal/Space/CurationInfo.vue';
import {
  checkSubscribe,
  getCurationInfoApi,
  setMappingCuration,
  updateConfirmCuration
} from '@/service/api/profileApi';
import PopUpModal from '@/components/modal/common/PopUpModal.vue';
export default {
  props: {
    updatecurationinfo: {
      type: Function,
      required: false,
      default: null
    },
    linkmyspace: {
      type: Function,
      required: false,
      default: null
    }
  },
  components: {
    CancelModal,
    CommonConfirm,
    SpaceManageSlot,
    BuildingProgressBar,
    BuildingManageFooter,
    PopUpModal,
    PreViewSelectCuration,
    CurationInfo
  },
  data() {
    return {
      btnDisabled: false,
      curationObject: {},
      cancelStatus: false,
      cancelCheckStatus: false,
      selectSpaceId: localStorage.getItem('spaceId'),
      domesticRate: -1,
      foreignRate: 0,
      isShowCurationInfo: false,
      isShowOverValue: false,
      curationId: null,
      color: null,
      bottomMaterialList: [],
      target: [],
      curationInfo: null,
      showCurationInfo: false,
      popupModalText: '',
      isPopUpModal: false
    };
  },
  created() {
    this.getCurationInfo();
    setTimeout(() => {
      this.isShowCurationInfo = true;
    }, 500);
  },
  methods: {
    onClickDetailModal() {
      this.showCurationInfo = true;
    },
    async updateCurationStore() {
      try {
        if (this.btnDisabled) return;
        this.btnDisabled = true;

        const result = await setMappingCuration(this.selectSpaceId, this.domesticRate, this.foreignRate);
        const { resultCd: mappingCurationResultCd } = result.data;
        if (mappingCurationResultCd === '0000') {
          const { data } = await updateConfirmCuration(this.selectSpaceId);
          const { resultCd: confirmResultCd } = data;
          if (confirmResultCd === '0000') {
            this.$router.push({ name: 'SpaceInsertGenreV2' }).catch(() => {});
          } else {
            throw Error(confirmResultCd);
          }
        } else {
          throw Error(mappingCurationResultCd);
        }
      } catch (error) {
        console.log('큐레이션 정보 업데이트 : ' + JSON.stringify(error));
      } finally {
        this.btnDisabled = false;
      }
    },
    onCloseModal() {
      this.isPopUpModal = false;
      this.$router.push({ name: 'buildingBridge' }).catch(() => {});
    },
    onDeleteSpace(msg) {
      this.isPopUpModal = true;
      this.popupModalText = msg;
    },
    onCancelCheckStatusConfirmNo() {
      this.linkmyspace(this.selectSpaceId);
    },
    async onCancelCheckStatusConfirmYes() {
      const { isSuccess, msg } = await this.updatecurationinfo({
        spaceId: this.selectSpaceId,
        domesticRate: this.domesticRate,
        foreignRate: this.foreignRate,
        period: [4, 5].join(',')
      });

      if (isSuccess) {
        this.cancelCheckStatus = false;
        this.cancelStatus = true;
      } else {
        this.onDeleteSpace(msg);
      }
    },
    onClickPre() {
      this.$router.push({ name: 'SpaceInsertStoreTargetV2' });
    },
    onClickOverValue() {
      this.isShowCurationInfo = false;
      setTimeout(() => {
        this.isShowOverValue = true;
      }, 500);
    },
    onClickDot(rate) {
      this.domesticRate = parseInt(rate);
      this.foreignRate = parseInt(100 - this.domesticRate);
      this.isShowOverValue = false;
    },
    backPage() {
      checkSubscribe(this.selectSpaceId).then(res => {
        const { resultCd, result } = res.data;
        if (resultCd === '0000') {
          if (result === 'S') {
            this.cancelCheckStatus = true;
          } else {
            this.$router.push({ name: 'buildingBridge' }).catch(() => {});
          }
        }
      });
    },
    async getCurationInfo() {
      try {
        const { data } = await getCurationInfoApi(this.selectSpaceId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          this.curationInfo = result;
          const { domesticRate, foreignRate, color, curationId, material, target } = result;
          this.color = color;
          this.curationId = curationId;
          this.bottomMaterialList = material;
          this.target = target;
          if (domesticRate) {
            this.domesticRate = parseInt(domesticRate);
            this.foreignRate = parseInt(foreignRate);
          } else {
            this.domesticRate = 50;
            this.foreignRate = 50;
          }
        }
      } catch (error) {
        console.log('큐레이션 정보 조회 : ' + error);
      }
    }
  },
  computed: {
    rightBtnDisabled() {
      return this.btnDisabled;
    }
  }
};
</script>
<style scoped src="@/assets/css/building/spaceinsertcountry.css"></style>
